<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<br/><p style="text-indent:0em">To Lois – for believing in my journey.</p>
<br/><p style="text-indent:0em">To Dave – for tall persons hugs.</p>
<br/><p style="text-indent:0em">To Henry – for being my book champion and for asking me, ‘When will your book be published Aunty Becki?’</p>
<br/><p style="text-indent:0em">To Savannah – who inspired the twins and is my ‘Katy’.</p>
<br/><p style="text-indent:0em">To anyone who knows what it’s like when life throws you a curved ball. Let that curved ball become your axis from which to spin something beautiful again.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?8720d740